import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["pinLocation", "isTrellisCompatibleComponent"],
  _excluded2 = ["pinLocation", "isTrellisCompatibleComponent"];
import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import BaseToolbar, { TrellisBaseToolbar } from './BaseToolbar';
import { PINNED_TOOLBAR_FONT_SIZE, PINNED_TOOLBAR_ICON_SIZE, PINNED_TOOLBAR_LINE_HEIGHT, PINNED_TOOLBAR_HEIGHT, CORNER_PLACEMENTS } from './constants';
import { withNonTrellisForwardRefRenderFunc, withTrellisForwardRefRenderFunc } from '../withTrellisCompatibleHoc';

// Give corner radius to the opposite corner of the pin location
import { jsx as _jsx } from "react/jsx-runtime";
const buttonRoundingFromPinLocation = pinLocation => {
  let firstButtonRounding;
  let lastButtonRounding;
  switch (pinLocation) {
    case 'left top':
    case 'top left':
      lastButtonRounding = 'bottom right';
      break;
    case 'left bottom':
    case 'bottom left':
      lastButtonRounding = 'top right';
      break;
    case 'right top':
    case 'top right':
      firstButtonRounding = 'bottom left';
      break;
    case 'bottom right':
    case 'right bottom':
      firstButtonRounding = 'top left';
      break;
    default:
      throw new Error(`Invalid pinLocation (${pinLocation})`);
  }
  return {
    firstButtonRounding,
    lastButtonRounding
  };
};
const BasePinnedToolbarRender = (props, ref) => {
  if (props.isTrellisCompatibleComponent) {
    const {
        pinLocation
      } = props,
      otherProps = _objectWithoutPropertiesLoose(props, _excluded);
    const {
      firstButtonRounding,
      lastButtonRounding
    } = buttonRoundingFromPinLocation(pinLocation);
    return /*#__PURE__*/_jsx(TrellisBaseToolbar, Object.assign({
      iconUse: "pinned",
      firstButtonRounding: firstButtonRounding,
      lastButtonRounding: lastButtonRounding,
      onlyLeftAndRightButtonBorders: true
    }, otherProps, {
      forwardedRef: ref
    }));
  }
  const {
      pinLocation
    } = props,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded2);
  const {
    firstButtonRounding,
    lastButtonRounding
  } = buttonRoundingFromPinLocation(pinLocation);
  return /*#__PURE__*/_jsx(BaseToolbar, Object.assign({
    fontSize: PINNED_TOOLBAR_FONT_SIZE,
    iconSize: PINNED_TOOLBAR_ICON_SIZE,
    lineHeight: PINNED_TOOLBAR_LINE_HEIGHT,
    height: PINNED_TOOLBAR_HEIGHT,
    firstButtonRounding: firstButtonRounding,
    lastButtonRounding: lastButtonRounding,
    onlyLeftAndRightButtonBorders: true
  }, otherProps, {
    forwardedRef: ref
  }));
};
BasePinnedToolbarRender.propTypes = {
  pinLocation: PropTypes.oneOf(CORNER_PLACEMENTS).isRequired
};
export const LegacyPinnedToolbar = /*#__PURE__*/forwardRef(withNonTrellisForwardRefRenderFunc(
// @ts-expect-error propTypes don't play well with trellis hoc
BasePinnedToolbarRender));
LegacyPinnedToolbar.displayName = 'LegacyPinnedToolbar';
export const TrellisPinnedToolbar = /*#__PURE__*/forwardRef(withTrellisForwardRefRenderFunc(
// @ts-expect-error propTypes don't play well with trellis hoc
BasePinnedToolbarRender));
TrellisPinnedToolbar.displayName = 'TrellisPinnedToolbar';
export default LegacyPinnedToolbar;